// extracted by mini-css-extract-plugin
module.exports = {"maskIcon":"qBDvXfo","lightIcon":"_2JIZz-0 qBDvXfo","darkIcon":"_2UT1lai qBDvXfo","blackIcon":"_2Dd1zdj qBDvXfo","close":"_1xgEXu7 _2Dd1zdj qBDvXfo"};